import { useRouteError, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export function ErrorBoundaryPage() {
  const error = useRouteError();
  const { t } = useTranslation('common');
  const message = error instanceof Error ? error.message : t('errors.generic');

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-4 text-center">
      <p className="text-4xl font-bold tracking-tighter">{t('errors.generic')}</p>
      <code className="max-w-xl rounded-md bg-muted px-3 py-2 text-sm text-muted-foreground">
        {message}
      </code>
      <Button asChild>
        <Link to="/">{t('nav.dashboard')}</Link>
      </Button>
    </div>
  );
}
